import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const SiteSettingsContext = createContext();

export const SiteSettingsProvider = ({ children }) => {
  const [siteSettings, setSiteSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    
    axios.get('https://vetforcesolutions.com/backend/api/site_settings')
      .then(res => {
        if (res.data && res.data.err_code === 'valid') {
          setSiteSettings(res.data.data);
        }
      })
      .catch(err => {
        console.error('Failed to fetch site settings:', err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ siteSettings, loading }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext); 